<template>
  <div>
    <v-btn small rounded color="error" @click="reallyDelete">
      Apagar 
      <v-icon right>mdi-delete</v-icon>
    </v-btn>

    <dialog-loading v-if="loading" loadingText='Apagando'></dialog-loading>

  </div>
</template>


<script>

import Vue from "vue";
import { mapActions, mapState, mapMutations } from "vuex";
import validations from "@/mixins/validations";
import Api from '@/api/index'

export default {
  name: 'ButtonDelete',
  mixins: [validations],
  data() {
    return {
      loading: false,
      dialog: false,
    };
  },
  methods: {
    reallyDelete(){
      this.$swal({
        title: `Apagar plano de ação?`,
        text: "O plano de ação será removido, e essa ação não pode ser revertida.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim",
        confirmButtonColor: this.$vuetify.theme.themes['light'].primary,
        cancelButtonText: "Não"
      }).then(r=>{
        if (r.isConfirmed) {
          this.loading = true;
          this.deleteActionPlan()
        }
      })
    },
    deleteActionPlan(){
      Api.ActionPlan.delete(this.$route.params.id).then(r=>{
        this.addNotification({type: 'success', msg: 'Atualizado com sucesso!'})
        this.setOneActionPlan({})
        this.$router.push('/action_plans')
      }).catch(err => {
        this.addNotification({type: 'error', msg: `Houve um erro: ${err}`})
      }).finally(()=> {
        this.loading = false;
      })
    },
    ...mapActions({
      addNotification: "Notification/add",
      // getOneActionPlan: "ActionPlan/getOneActionPlan",
      // getAllMyActionPlans: "ActionPlan/getAllMyActionPlans"
    }),
    ...mapMutations({
      setOneActionPlan: "ActionPlan/setOneActionPlan"
    })
  },
  computed: {
    name() {
      return this.data 
    },
    ...mapState({
      profile: state=> state.User.oneUser
    })
  },
};
</script>